import { useEffect, useState } from "react";
import { Spin } from "antd";
import { usePageLoadStatus } from "./pageLoadStatus";

// При смяна на екрана старият стои, докато новият е готов — обикновено част
// от секундата (кодът идва от кеша на service worker-а). Spinner за толкова
// би бил само примигване; показва се, ако чакането се проточи.
const SPINNER_DELAY_MS = 300;

/**
 * Единственият spinner на кода при отваряне — на мястото на този в
 * `AuthorizedRoute` (центъра на екрана). Не спира кликовете: човекът може да
 * отвори друг модул, докато чака.
 */
export default function PageLoadingIndicator() {
  const status = usePageLoadStatus();
  if (status === "idle") return null;
  if (status === "fallback") return <CenteredSpinner />;
  return <DelayedSpinner />;
}

function DelayedSpinner() {
  const [isDelayOver, setIsDelayOver] = useState(false);

  useEffect(() => {
    const timeout = window.setTimeout(() => setIsDelayOver(true), SPINNER_DELAY_MS);
    return () => window.clearTimeout(timeout);
  }, []);

  return isDelayOver ? <CenteredSpinner /> : null;
}

function CenteredSpinner() {
  return (
    <div className="pointer-events-none fixed inset-0 z-[1000] flex items-center justify-center">
      <Spin size="large" />
    </div>
  );
}
